'use client'

import { ROUTES } from '@/core/constants/routes'
import { Button } from '@/core/ui/atoms/button'
import { FormInput } from '@/core/ui/forms/input'
import { CheckCircle, CornerUpLeft } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { FormProvider } from 'react-hook-form'
import { useVerifyAccount } from './use-verify-account'

type Props = {
  onSuccess: () => void
  onClose: () => void
}

export const VerificationForm: React.FC<Props> = props => {
  const t = useTranslations()
  const { form, handleSubmit, isPending } = useVerifyAccount(props)

  return (
    <div className='px-1 py-3 sm:px-10 sm:py-5'>
      <div className='mb-3 flex items-center gap-3 sm:gap-6'>
        <Link href={ROUTES.prev}>
          <CornerUpLeft className='h-5 w-5 cursor-pointer text-gray-700' />
        </Link>
        <h1 className='text-mountain-bluebird text-xl font-semibold sm:text-[28px]'>
          {t('verifyAccount.title')}{' '}
        </h1>
      </div>

      <p className='text-mountain-bluebird mb-6 text-base sm:text-lg'>
        {t('verifyAccount.subtitle')}
      </p>

      <FormProvider {...form}>
        <form onSubmit={handleSubmit} className='space-y-4'>
          <FormInput
            name='otp_code'
            label={t('forms.codeLabel')}
            control={form.control}
          />

          <Link
            href={'#'}
            className='text-cyan-blue text-sm font-bold underline sm:text-base'
          >
            {t('code.requestCode')}
          </Link>

          <Button
            loading={isPending}
            className='mt-5 h-12 w-full font-semibold text-white sm:py-3'
          >
            {t('actions.continue')}
          </Button>

          <div className='border-creamed-cron text-creamed-cron flex items-start gap-2 rounded-md border bg-[#F4F5E6] px-3 py-2 text-sm sm:text-base'>
            <CheckCircle className='text-creamed-cron mt-0.5 h-5 w-5 flex-shrink-0' />

            <div>
              <p className='font-medium'>{t('code.sentMsg')}</p>
              <p className='text-xs sm:text-sm'>
                {t('code.waitMsg', { time: 20 })}
              </p>
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  )
}
